// ----------------------
// ENTITIES
// ----------------------
export const CLEAR_ENTITIES = 'CLEAR_ENTITIES';
export const CLEAR_ENTITY = 'CLEAR_ENTITY';
export const RECEIVE_ENTITIES = 'RECEIVE_ENTITIES';
export const RECEIVE_ENTITY = 'RECEIVE_ENTITY';

// ----------------------
// SESSIONS
// ----------------------
export const SESSION_LOADING = 'SESSION_LOADING';
export const SESSION_GUID = 'SESSION_GUID';
export const SET_SESSION = 'SET_SESSION';
export const SET_PUBLIC_KEY = 'SET_PUBLIC_KEY';
export const SET_IS_MODAL = 'SET_IS_MODAL';
export const SET_MODE = 'SET_MODE';
export const PI4_CONFIRM = 'PI4_CONFIRM';

// ----------------------
// AUTHENTICATION
// ----------------------
export const TOKEN_LOADING = 'TOKEN_LOADING';
export const SET_TOKEN = 'SET_TOKEN';

// ----------------------
// GENERAL
// ----------------------
export const CLEAR_ERRORS = 'CLEAR_ERRORS';
export const CLEAR_ERROR_MESSAGES = 'CLEAR_ERROR_MESSAGES';
export const SET_DEBUG = 'SET_DEBUG';
export const SET_ERROR = 'SET_ERROR';
export const ENABLE_RETHROW = 'ENABLE_RETHROW';
export const DISABLE_RETHROW = 'DISABLE_RETHROW';

// ----------------------
// FORMS
// ----------------------
export const UPDATE_INPUT = 'UPDATE_INPUT';

export const POST_APPROVAL_PLAID_REQUEST_STARTED =
  'POST_APPROVAL_PLAID_REQUEST_STARTED';
export const POST_APPROVAL_PLAID_STATUS_RECEIVED =
  'POST_APPROVAL_PLAID_STATUS_RECEIVED';
export const POST_APPROVAL_PLAID_REQUEST_FAILED =
  'POST_APPROVAL_PLAID_REQUEST_FAILED';
export const POST_APPROVAL_PLAID_IDEMPOTENCY_KEY_SET =
  'POST_APPROVAL_PLAID_IDEMPOTENCY_KEY_SET';
export const POST_APPROVAL_PLAID_RESET = 'POST_APPROVAL_PLAID_RESET';
